import { render, staticRenderFns } from "./deleteHousekeepingFeeType.vue?vue&type=template&id=8c153970"
import script from "./deleteHousekeepingFeeType.vue?vue&type=script&lang=js"
export * from "./deleteHousekeepingFeeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports